<template>
  <div class="outpage" v-loading.fullscreen.lock="loading">
    <div class="w100 sta1 flex-cc">
      <div class="flex-cc">
        <img class="mlogo1" src="../assets/logo.png" alt="">
        <div class="mlogo2">
          <div class="mlp1">网络空间内生安全知识平台</div>
          <div class="mlp2">KNOWLEDGE SYSTEM OF CYBERSPACE ENDOGENOUS SAFETY&SECURITY</div>
        </div>
      </div>
      <div class="sta3">课程案例</div>
    </div>
    <div class="w100 stamiddle" ref="scrollContainer">
      <div v-show="detailnum == 1" class="stam1">
        <div class="forum2 mt10">
          <!--          <el-tooltip class="w100 overflow" effect="dark" :content="scope.row.date" placement="top-start">-->
          <!--            <el-button class="noborder w100">-->
          <!--              {{ scope.row.date }}scope.row.datescope.row.datescope.row.datescope.row.datescope.row.datescope.row.date-->
          <!--            </el-button>-->
          <!--          </el-tooltip>-->
          <div class="w100">
            <div class="flex-hlc mbom20 newke" v-for="(item,index) in datalist">
              <div class="kewlist1">
                <img :src="item.img?item.img:require('../assets/img/motitle.png')" alt="">
              </div>
              <div class="flex-scs kewlist2">
                <div class="w100 mbom5">
                  <el-tooltip class="w100 overflow" effect="dark" :content="item.title" placement="top-start">
                    <el-button class="noborder w100">
                      {{ item.title }}
                    </el-button>
                  </el-tooltip>
                </div>
                <div class="listz3 over6 w100 mbom5">{{ item.content }}</div>
                <div class="w100">
                  <div class="lookinfo-x1" @click="lookinto(item)">查看详情</div>
                </div>
              </div>
            </div>
          </div>

          <div class="w100 mt20 flex-cc">
            <el-pagination
                v-if="datalist.length > 0"
                background
                layout="prev, pager, next"
                :current-page.sync="pageObj.currentPage"
                :page-size="pageObj.pageSize"
                :total="pageObj.total"
                @current-change="pageChange">
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-show="detailnum == 2" class="stam1">
        <div class="w100 sta6"><span class="cur" @click="tohome">首页></span><span class="cur"
                                                                                   @click="backyuan">课程案例></span><span>详情</span>
        </div>
        <div class="w100 newwai-content flex-hl">
          <div class="sta4 mt20 w100" style="min-height: 49vh !important;">
<!--            <div class="wenxiang over1">{{ articleinfo.title }}</div>-->
            <el-tooltip class="w100 overflow" effect="dark" :content="articleinfo.title" placement="bottom">
              <el-button class="titleborder w100">
                {{ articleinfo.title }}
              </el-button>
            </el-tooltip>
            <div class="wenxiang2 flex-cc" v-if="articleinfo">
              <div>{{ articleinfo.user }}</div>
              <div class="wms1">|</div>
              <div>{{ articleinfo.gmtCreate }}</div>
              <div class="wms1">|</div>
              <div class="flex-cc">
                <img class="wxim1" src="../assets/img/liulan.png" alt="">
                <span>{{ articleinfo.views }}</span>
              </div>
            </div>
            <div class="w100 flex-hl">
<!--              <div class="w70" style="color: white !important;" v-html="articleinfo.content">-->
<!--              </div>-->
<!--              zzz-->
              <div class="art1" style="color: white !important;" v-html="articleinfo.content"></div>
              <div class="art2">
                <div class="dingzhang flex-hlc">
                  <img src="../assets/img/dui.png" alt="">
                  <span>章节列表</span>
                </div>
                <div class="zhanglist"  ref="scrollContainernew" @scroll="handleScroll">
                    <div class="zhangnei cur" v-for="(item,idx) in zhangpagelist" :key="idx" @click="setinfo(item)">
                      <div class="w100">
                        <img class="zhang-img1" :src="item.img?item.img:require('../assets/img/motitle.png')" alt="">
<!--                        <el-tooltip class="zhang-t2" effect="dark" :content="item.title" placement="top-start">-->
                        <el-tooltip style="width: 64%;" effect="dark" :content="item.title" placement="top-start">
                            <div class="w100 multiline-ellipsis">
                              {{ item.title }}
                            </div>
                        </el-tooltip>
                      </div>
                      <div class="zhang-t3 over4 w100">
                        {{item.content}}
                      </div>
                    </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div style="width: 100%;height: 40px;"></div>
      </div>
      <div class="bottomd flex-cc">
        <span>Copyright ◎ 2026 紫金山实验室,All Rights Reserved.</span>
        <span class="shus"></span>
        <img src="../assets/guohui.png" class="jinghui" alt="">
        <span>苏CP备14016373号-4</span>
      </div>
    </div>
    <div class="dingping" v-if="showpdf">
      <img class="closepdf" @click="showpdf = false" src="../assets/img/close.png" alt="">
      <iframe
          :src="pdfurl"
          frameborder="0"
          width="100%"
          height="100%"
      ></iframe>
    </div>
    <el-dialog
        title=""
        class="tanpassk"
        append-to-body
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="showMask"
        width="60%">
      <div class="fenxd1 flex-hl">
        <div class="choosed1">
          <el-input
              placeholder="搜索"
              v-model="filterText"
              clearable>
          </el-input>
          <div class="w100 mt10 mbom10">
            <el-checkbox
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange">
              <span class="quanx">全选</span>
            </el-checkbox>
          </div>
          <div class="choosed6">
            <el-tree
                :data="datatree"
                show-checkbox
                node-key="id"
                ref="tree"
                :filter-node-method="filterNode"
                default-expand-all
                @check="handleCheck"
                :props="topprops"
                :expand-on-click-node="false"
                :check-on-click-node="true">
      <span class="custom-tree-node flex-hlc" slot-scope="{ node, data }">
<!--        <span class="flex-hlc">-->
          <img v-if="data.userList" class="buimg" src="../assets/img/bum.png" alt="">
          <span class="butext">{{ node.label }}</span>
        <!--        </span>-->
      </span>
            </el-tree>
          </div>

        </div>
        <div class="choosed2">
          <div class="choosep2">已选择({{ checktreelist.length }}/{{ checkzong }})</div>
          <div class="w100 choosewai">
            <div class="choosep1 flex-cc flex-box" v-for="(item,index) in checktreelist">
              <img class="choosed4" src="../assets/img/ren.png" alt="">
              <div class="choosed3 flex-1 over1">{{ item.name }}</div>
              <img @click="delpeople(item,index)" class="choosed5" src="../assets/img/x.png" alt="">
            </div>
          </div>
          <div class="choosed7 w100 flex-hr">
            <div @click="noreplay" class="quxiaohui mr20">取消</div>
            <div @click="subreplay()" class="querenlan">分享</div>
          </div>
        </div>


      </div>
    </el-dialog>
  </div>
</template>

<script>
import Editor from '@/components/Richtext';

export default {
  name: 'statistics',
  components: {
    Editor
  },
  props: {
    pushnum: [String, Object, Array, Number],
  },
  data() {
    return {
      content: '撒撒打发撒打发手打阿发送达啊啊啊\n啊啊啊啊啊\n啊啊啊啊啊啊啊啊啊啊啊啊啊阿发法撒旦的点点滴滴滴啊啊啊啊啊啊啊阿发法撒旦的点点滴滴滴答滴答',
      contenthui: '',
      filterText: '',
      titlew: '中外专家为构建网络安全免疫系统建言献策',
      cursorPosition: 0,//评论当前光标位置
      cursorPositionhui: 0,//回复当前光标位置
      isComposing: false, // 中文输入法状态标记
      showPicker: false,
      showMask: false,
      showpdf: false,
      showPickerhui: false,
      replaylook: false,
      pdfurl: '',
      pdfname: '',
      pickerPlacement: 'bottom-start',
      datalist: [],
      pageObj: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      pagezhang: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      sform: {
        input: '',
        time: '',
        user: '',
      },
      checkAll: false,
      checkzong: 0,//总数量
      checkxuan: 0,//选中的数量
      isIndeterminate: false,
      checktreelist: [],//选中的树的二级
      datatree: [],
      topprops: {
        label: 'name',
        children: 'userList',
        value: 'id',
        // emitPath:false
      },
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
      detailnum: 1,//1是列表2是详情
      loading: false,
      articleinfo: '',
      // 保存原始滚动位置
      scrollTop: 0,
      titlebu: '',
      richText: '',
      pdflist:[],
      parinfo: true,//是否没有搜索条件 true是没有
      queryinfo: '',//传过来的值
      dinglist: [],//顶部小分类列表
      neilist: [],//顶部外层分类列表
      dingid: '',//选中的id=categoryId	分类id
      titleinfo: '',
      userinfo: JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null,
      zhangnum:1,//滚动页码
      waiinfo:'',//外层点击的数据
      zhanginfo:'',//内部选中的数据
      zhangpagelist:[],//章节列表
      zhangtotal:0,
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    pushnum(newVal) {
      this.detailnum = 1;
      this.$refs.scrollContainer.scrollTop = 0;
    },
    // 监听遮罩层显示/隐藏，控制滚动锁定
    showpdf(newVal) {
      if (newVal) {
        // 显示遮罩时，禁止背景滚动
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        document.body.style.position = 'fixed'
        document.body.style.top = `-${this.scrollTop}px`
        document.body.style.width = '100%'
      } else {
        // 隐藏遮罩时，恢复滚动
        document.body.style.position = ''
        document.body.style.top = ''
        // 恢复到原来的滚动位置
        window.scrollTo(0, this.scrollTop)
      }
    },
  },
  // 11
  mounted() {
    console.log('konwledge接收参数', this.$route.query)
    this.showpdf = false;
    this.zhangnum = 1;
    this.articleinfo = '';
    this.zhangpagelist = [];
    this.getdata();
    // this.getuserlist();//获取分享人的树
    this.$refs.scrollContainernew.addEventListener('scroll', this.handleScroll);
  },
  // 22
  methods: {
    lookinto(val){
      this.waiinfo = val;
      this.togetpage();
    },
    handleScroll(event) {
      const container = event.target;
      if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
        console.log('触底了');
        if (this.zhangnum * this.pagezhang.pageSize <= this.zhangtotal) {
          // 触底逻辑
          this.zhangnum = this.zhangnum+1;
          console.log('this.zhangnum',this.zhangnum)
          this.togetpage(1)
        } else {
          return
        }
      }
    },
    lookpdf(val) {
      console.log(val)
      this.pdfurl = val;
      this.showpdf = true;
    },
    tohome() {
      this.$router.push({
        path: '/',
      })
    },
    backyuan() {
      this.detailnum = 1;
      this.showpdf = false;
      this.zhangnum = 1;
      this.articleinfo = '';
      this.zhangpagelist = [];
      this.$router.push({
        path: '/knowledgecourse',
        query: {
          // 只保留非 'param1' 的查询参数
          ...this.$route.query,
          artiid: null // 这里通过设置为 null 来“删除”这个参数
        }
      }).then(() => {
        // 删除操作后的处理逻辑
      });
    },
    getuserlist() {
      let data = {}
      this.$http({
        url: 'user/tree',
        method: 'post',
        data: this.$form(data)
      }).then((res) => {
        this.datatree = res.data.deptList;
        this.checkzong = res.data.total;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    resetsear() {
      this.sform = Object.assign(this.sform, this.$options.data().sform);
      this.datalist = [];
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.getdata();
    },
    subsear() {
      this.datalist = [];
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.getdata(1);
    },
    // 获取分页数据
    getdata(val) {
      let data={}
      data.pageNumber = this.pageObj.currentPage;
      data.pageSize = this.pageObj.pageSize;
      this.$http({
        url: "course/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObj.total = res.data.total;
        this.datalist = res.data.records;
      });
    },
    // 进入内部获取分页 zzz
    togetpage(val) {
      let data = {
        courseId: this.waiinfo.id
      }
      data.pageNumber = this.zhangnum;
      data.pageSize = this.pagezhang.pageSize;
      this.$http({
        url: "chapter/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        if(res.data.records.length > 0){
          this.zhangpagelist = this.zhangpagelist.concat(res.data.records);
          this.zhangtotal = res.data.total;
          if(!val){
            this.zhanginfo =res.data.records[0];
            console.log('zhanginfo',this.zhanginfo)
            this.getdetail()
          }

        }else{
          this.$refs.scrollContainer.scrollTop = 0;
          this.detailnum = 2
        }
        console.log('this.zhangpagelist',this.zhangpagelist)
      });
    },
    setinfo(val){
      this.zhanginfo = val;
      console.log('zhanginfo',this.zhanginfo)
      this.getdetail();
    },
    // ddd
    getdetail(){
      this.$refs.scrollContainer.scrollTop = 0;
      let data = {
        chapterId: this.zhanginfo.id
      }
      this.$http({
        url: "chapter/detail",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        if(res.data.content){
            res.data.content = this.replacePStylesEnhanced(res.data.content);
        }
        this.articleinfo = res.data;
        this.detailnum = 2;
      });
    },
    delpeople(val, idx) {
      // console.log('this.checktreelist.indexOf(val.id)', this.checktreelist.indexOf(val.id))
      this.checktreelist.splice(idx, 1);
      this.$refs.tree.setCheckedNodes(this.checktreelist);
      this.handleCheck();
    },
    // 全选
    handleCheckAllChange(val) {
      this.$refs.tree.setCheckedNodes(val ? this.datatree : []);
      this.handleCheck()
    },
    // 选中的值-判断全选全不选
    handleCheck() {
      const checkedCount = this.$refs.tree.getCheckedNodes().length;//树的总长度
      const totalCount = this.countNodes(this.datatree)//选中的长度
      this.checkAll = checkedCount === totalCount;
      this.isIndeterminate = checkedCount > 0 && checkedCount < totalCount;
      // console.log('this.$refs.tree', this.$refs.tree.getCheckedNodes(), checkedCount, totalCount);
      this.checktreelist = this.$refs.tree.getCheckedNodes().filter(item => !item.userList);
      // console.log('checktreelist', this.checktreelist)
    },
    countNodes(data) {
      return data.reduce((total, node) => {
        return total + 1 + (node.userList ? this.countNodes(node.userList) : 0)
      }, 0)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    openfx() {
      if (this.articleinfo.share) {
        this.checktreelist = [];
        this.showMask = true;
        this.checkAll = false;
        this.$nextTick(() => {
          this.$refs.tree.setCheckedNodes([]);
        })
      }
    },
    downfile(item) {
      // 使用axios下载文件，自动携带token
      this.$http({
        url: 'article/download',
        method: 'GET',
        params: {
          articleId: this.articleinfo.id,
          idx: item.idx
        },
        responseType: 'blob' // 重要：设置响应类型为blob
      }).then(res => {
        // 创建blob URL
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        // 从响应头获取文件名，如果没有则使用默认名称
        const contentDisposition = res.headers['content-disposition'];
        let filename = 'download';
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
            // 处理中文文件名编码
            if (filename.startsWith('UTF-8\'\'')) {
              filename = decodeURIComponent(filename.replace('UTF-8\'\'', ''));
            }
          }
        }
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        // 清理
        window.URL.revokeObjectURL(url);
        setTimeout(() => {
          document.body.removeChild(a);
        }, 100);
      }).catch(err => {
        console.error('下载失败:', err);
        this.$message({
          message: '下载失败，请稍后重试',
          type: 'error',
          duration: 2000
        });
      });
    },
    openfile(val) {
      console.log(val)
      return
      // this.pdfurl = '';
      // this.pdfname = val.name;
      // if (!this.articleinfo.preview) {
      //   this.$message({
      //     message: '暂无预览权限！',
      //     type: 'warning'
      //   });
      //   return false
      // }
      // let data = {
      //   articleId: this.articleinfo.id,
      //   idx: val.idx
      // }
      // this.loading = true;
      // this.$http({
      //   url: "article/preview",
      //   method: "POST",
      //   data: this.$form(data)
      // }).then(res => {
      //   this.$crypto.decryptBackendData(res.data);
      //   this.pdfurl = this.$crypto.decryptBackendData(res.data);
      //   this.loading = false;
      //   this.$refs.scrollContainer.scrollTop = 0;
      //   this.showpdf = true;
      //   // console.log('res2',res.data,this.$crypto.decryptBackendData(res.data))
      //   // window.open(this.$crypto.decryptBackendData(res.data), "_blank");
      // }).catch(err => {
      //   this.loading = false;
      // });

    },
    replacePStylesEnhanced(htmlString) {
      // 创建临时 DOM 元素来解析 HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // 获取所有的 p 元素
      // const pe0 = tempDiv.querySelectorAll('p:has(video)');
      const allParagraphs = this.$el.querySelectorAll('p');
      const pe0 = Array.from(allParagraphs).filter(p =>
          p.querySelector('video') !== null
      );
      const pe1 = tempDiv.querySelectorAll('p');
      const pe2 = tempDiv.querySelectorAll('ul');
      const pe3 = tempDiv.querySelectorAll('h1');
      const pe4 = tempDiv.querySelectorAll('h2');
      const pe5 = tempDiv.querySelectorAll('h3');
      const pe6 = tempDiv.querySelectorAll('h4');
      const pe7 = tempDiv.querySelectorAll('h5');
      const pe8 = tempDiv.querySelectorAll('span');
      const pe9 = tempDiv.querySelectorAll('div');
      const pe10 = tempDiv.querySelectorAll('ol');
      const pe11 = tempDiv.querySelectorAll('img');
      const pe12 = tempDiv.querySelectorAll('video');
      console.log('pe12', pe12)
      // 遍历每个 p 元素并修改样式
      pe0.forEach(p => {
        p.style.width = '100%';
      });
      pe1.forEach(p => {
        p.style.width = '100%';
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe2.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe3.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe4.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe5.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe6.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe7.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe8.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe9.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe10.forEach(p => {
        p.style.color = 'rgb(255, 255, 255)';
        p.style.backgroundColor = '';
      });
      pe11.forEach(p => {
        p.style.maxWidth = '100%';
      });
      pe12.forEach(video => {
        console.log('video',video,video.width,video.height);
        video.style.width = video.width+'px';
        video.style.height = video.height+'px';
        video.style.margin = 'auto';
        video.style.maxWidth = '100%';
      });
      // 设置所有视频自动循环播放
      Array.from(pe12).forEach(video => {
        // 设置视频属性
        video.loop = true;
        video.autoplay = true;
        video.muted = true; // 静音以提高自动播放成功率
        video.playsinline = true;
        video.controls = true; // 显示控制条，用户可以暂停/播放

        // 尝试自动播放（静音模式下通常会被允许）
        video.play().catch(error => {
          console.log('自动播放失败，用户需手动播放:', error);
          // 自动播放失败时，用户可以通过控制条手动播放
        });
      });
      // 返回修改后的 HTML 字符串
      return tempDiv.innerHTML;
    },

    getfile(val) {
      console.log(val)
      let data = {
        articleId: this.articleinfo.id,
        idx: val.idx
      }
      this.loading = true;
      this.$http({
        url: "article/preview",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        let pdfurl = this.$crypto.decryptBackendData(res.data);
        this.pdflist.push({name: val.name, url: pdfurl});
        console.log('this.pdflist', this.pdflist)
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      });
    },
    changelei(val) {
      this.dingid = val.id;
      this.datalist = [];
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.getdata();
    },
    subbuopen() {
      this.detailnum = 3;
    },
    handleRowClick(row, column, event) {
      this.detailnum = 2;
      // 这里可以添加业务逻辑
    },
    nobu() {
      this.detailnum = 1;
    },
    subbu() {

    },
    // 富文本
    neiclick(val) {
      this.richText = val;
    },
    // 取消回复
    noreplay() {
      this.showMask = false;
    },
    // 分享
    subreplay() {
      if (this.checktreelist.length == 0) {
        this.$message({
          message: '请选择分享人！',
          type: 'warning'
        });
        return false
      }
      let data = {
        articleId: this.articleinfo.id,
        toUserId: this.checktreelist.map(item => item.id).toString(),
      }
      this.$http({
        url: "article/share",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.$message({
          message: '操作成功！',
          type: 'success'
        });
        this.showMask = false;
      });
    },
    // 回复
    replyx() {
      // this.replaylook = true;
      this.showMask = true;
    },
    fabu() {
      console.log('问你', this.content)
    },
    togglePicker() {
      this.showPicker = !this.showPicker;
    },
    togglePickerhui() {
      this.showPickerhui = !this.showPickerhui;
    },

    pageChange(page) {
      console.log('页码', page)
      this.pageObj.currentPage = page;
      this.$refs.scrollContainer.scrollTop = 0;
      this.getdata();
    },
  },
  beforeDestroy() {
    this.$refs.scrollContainernew.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<!--333-->
<style lang="scss" scoped>
.multiline-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: 3em;
  color: white;
}
.sta4 {
  padding: 40px 20px !important;
}
@media screen and (max-width: 1440px)  {
  .sformin .searbtn1{
    width: 50PX;
    height: 50PX;
    line-height: 50PX;
  }
  .sformin .searbtn2{
    width: 50PX;
    height: 50PX;
    line-height: 50PX;
  }
  /deep/ {
    .sformin .el-form-item__label{
      line-height: 50px !important;
    }
    .wnew200 .el-input__inner {
      width: 122px !important;
      height: 50px !important;
    }

    .wnew270 .el-input__inner {
      height: 50px !important;
      width: 250px !important;
    }
    .wnew270 .el-range-separator{
      line-height: 44px !important;
    }
  }
}
.clpdf {
  cursor: pointer;
  z-index: 1000;
  width: 25px;
  height: 25px;
}
.titleborder {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: center !important;
  font-size: 30px !important;
  font-weight: bold;
  margin-bottom: 10px;
}

.titleborder:hover {
  background: none;
  color: #fff !important;
}
</style>
<style lang="scss">
.newwai-content {
  height: max-content;
}

//改个外层名字再用
.tanpassk {
  .el-dialog {
    border-radius: 16px;
  }

  .el-dialog__body {
    padding: 0px;
    background: #0B3E73;
    border-radius: 16px;
    overflow: hidden;
  }

  .el-dialog__header {
    display: none;
  }

}

.fenx1 {
  width: 60px;
  height: 24px;
  color: #9FE2FF;
  font-size: 14px;
  border: 1px solid #0090FF;
  background: rgba(0, 144, 255, 0.5);
  text-align: center;
  margin-left: 20px;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}

.tishi {
  border: 1px solid #3B5474;
  background: rgba(59, 84, 116, 0.5);
  color: white;
}

.tishi:hover::after {
  content: "暂无分享权限";
  position: absolute;
  left: 0;
  top: 27px;
  background: #333;
  width: 100px;
  color: white;
  padding: 5px;
  border-radius: 4px;
}

.fenx2 {
  width: 16px;
  height: 16px;
  margin-right: 2px;
}

.kewlist1 {
  width: 500px;
  //max-height: 340px;
  height: 340px;
  border-radius: 16px 0 0 16px;
  img{
    width: 100%;
    //max-height: 340px;
    height: 340px;
    border-radius: 16px 0 0 16px;
  }
}
.kewlist2 {
  box-sizing: border-box;
  padding: 30px;
  border: 1px solid #0075C3;
  width:calc(100% - 500px);
  border-radius: 0 16px 16px 0;
  height: 100%;
  box-sizing: border-box;
  background: linear-gradient(33deg, #00A5EA 0%, #0E3E6C 100%);
  box-shadow: 2px 6px 20px 0px rgba(14,62,108,0.2);
}
.fll1 {
  font-size: 18px;
  color: white;
}

.fll2 {
  margin-right: 20px;
  margin-left: 20px;
}

.fll3 {
  cursor: pointer;
}

.leihot {
  color: #0090FF;
}

.wxim1 {
  width: 18px;
  height: 13px;
  margin-right: 5px;
}

.wxim2 {
  width: 18px;
  height: 16px;
  margin-right: 5px;
}

.but1 {
  width: 10%;
  color: white;
  text-align: right;
  box-sizing: border-box;
  padding-right: 20px;
  font-size: 16px;
}

.but2 {
  width: 90% !important;
}

.but3 {
  width: 90%;
  border-radius: 8px;
  overflow: hidden;
}

.sta4 {
  width: 100%;
  min-height: 70vh !important;
  box-sizing: border-box;
  padding: 40px 80px;
  border-radius: 16px;
  background: rgba(14, 62, 108, 0.5);
}

.sta5 {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 16px;
  background: rgba(14, 62, 108, 0.5);
  color: white;
}

.colorql {
  color: #A0B8E2;
}

.sta6 {
  font-size: 16px;
  color: white;
  margin: 20px 0;
}


.overflow {
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
<style scoped lang="scss">
.zhang-img1{
  //width: 150px;
  width: 34%;
  height: auto;
  max-height: 87px;
  margin-right: 2%;
  display: inline-block;
  float: left;
}
.zhang-t2{
  //width: calc(100% - 160px);
  width: 64%;
  display: inline-block;
  float: left;
  color: white;
}
.zhang-t3{
  font-size: 14px;
  color: white;
  white-space: pre-line;
}
.art1{
  width: 73%;
  margin-right: 2%;
}
.art2{
  width: 25%;
  border-radius: 16px;
  box-sizing: border-box;
  .dingzhang{
    height: 58px;
    box-sizing: border-box;
    padding: 0 20px;
    background: #0075C3;
    border-radius: 16px 16px 0 0;
    font-size: 16px;color: white;
    img{
      width: 21px;
      height: 24px;
      margin-right: 5px;
    }
  }
  .zhanglist{
    height: 1000px;
    overflow-y: auto;
    border: 1px solid #0075C3;
    box-sizing: border-box;
    border-radius:0 0 10px 10px;
    padding: 15px;
    .zhangnei{
      height: max-content;
      box-sizing: border-box;
      padding: 15px;
      border-radius: 10px;
      background: rgba(0,117,195,0.8);
      margin-bottom: 20px;
      &:nth-last-of-type(1){
        margin-bottom: 0;
      }
    }
  }
}
.lookinfo-x1{
  width: 150px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: white;
  background-image: url("../assets/img/xiang.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: inline-block;
  float: right;
  cursor: pointer;
}
.newke{
  height: 340px;
}
.stam1 {
  width: 1400px;
}

.outpage {
  height: calc(100vh - 80px);
  overflow: hidden;
}

.newkuanlo {
  width: max-content;
  max-width: 89%;
}

.w100 p {
  color: white !important;
}

.dingping {
  box-sizing: border-box;
  padding: 0px;
}

.wnew50 {
  width: 50% !important;
  box-sizing: border-box;
  padding: 20px !important;
}

.ifaout {
  box-sizing: border-box;
  position: relative;
  padding: 20px 20px;
  border-radius: 16px;
  margin-top: 20px;
  background: rgba(14, 62, 108, 0.9);
}

.pdf-name {
  font-size: 24px;
  color: white;
  font-weight: bold;
  margin-bottom: 10px;

  .pnammeov {
    width: 94%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.closepdf {
  position: absolute;
  right: 50px;
  top: 25px;
  cursor: pointer;
  z-index: 1000;
  width: 25px;
  height: 25px;
}

.downimg {
  width: 16px;
  height: 16px;
  margin-left: 10px;
}

.butext {
  width: 78%;
  //background: pink;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.choosed6 {
  height: 90%;
  width: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding-bottom: 20px;
}

.buimg {
  width: 16px;
  height: 16px;
  margin-right: 3px;
}

.quanx {
  color: white;
  font-size: 16px;
}

.choosep2 {
  color: white;
  margin-bottom: 10px;
}

.choosewai {
  height: 85%;
  margin-bottom: 1%;
  //background: cyan;
  //height: max-content;
  //max-height: 95%;
  overflow-y: auto;
}

.choosep1 {
  width: 187px;
  height: 54px;
  background: #1A5C9B;
  border: 1px solid #0090FF;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 0 20px;
  margin-right: 15px;
  margin-bottom: 15px;
  float: left;

}

.choosep1:nth-child(4n) {
  margin-right: 0;
}

.choosed4 {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.choosed5 {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.choosed3 {
  color: white;
  margin-left: 2px;
  margin-right: 2px;
  text-align: center;
}

.tanpassk .el-dialog .el-dialog__header {
  display: none !important;
  padding: 0 !important;
}

/deep/ {
  .custom-tree-node {
    width: 100%;
    //background: plum;
  }

  .choosed1 {
    .el-input__inner {
      border-radius: 20px;
      background: #02274C;
      border: 1px solid #02274C;
      color: white;
    }

    .el-checkbox__inner {
      width: 16px;
      height: 16px;
    }

    .el-checkbox__inner::after {
      height: 8px;
      left: 5px;
    }
  }

  .el-tree {
    background: transparent;
    color: white;
    font-size: 18px;
  }

  .el-tree-node__content {
    height: 35px;
    line-height: 35px;
    background-color: transparent !important;
  }

  /* 鼠标悬停时的背景色 */

  /* 当前选中节点的背景色 */
  .el-tree-node.is-current > .el-tree-node__content {
    background-color: transparent !important;
  }

  .el-tree-node__content:hover, .el-upload-list__item:hover {
    background: transparent;
  }

  .fenxd1 {
    height: 630px;
    //border-radius: 16px;
    background: #0E3E6C;
  }
}

.choosed1 {
  width: 25%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 16px 0 0 16px;
}

.choosed2 {
  width: 75%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 0 0 16px 16px;
  background: linear-gradient(0deg, #1A5C9B 0%, #093B6E 100%)
}

.sta9 {
  //width: 85%;
  color: #0090FF;
}

.sta8 {
  width: 26px;
  height: 30px;
  margin-right: 15px;
}

.sta7 {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  background: rgba(10, 40, 70, 0.8);
  border-radius: 16px;
  margin-top: 15px;
}



.listz2 {
  color: #B2B4CB;
}

.noborder {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: left !important;
  font-size: 24px !important;
  font-weight: bold;
}

.noborder:hover {
  background: none;
  color: #0090FF !important;
}
.noborder-t1 {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: left !important;
  font-size: 16px !important;
  font-weight: bold;
}

.noborder-t1:hover {
  background: none;
  color: #fff !important;
}
.noborder-t2 {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: left !important;
  font-size: 15px !important;
}

.noborder-t2:hover {
  background: none;
  color: #fff !important;

}

/deep/ {
  .but2 .el-input__inner {
    background: #0E3E6C;
    border: none !important;
    color: white;
    height: 50px;
    line-height: 50px;
  }
}

.stamiddle {
  height: calc(100vh - 160px);
  min-height: calc(100vh - 160px);
  overflow-y: auto;
  background-image: url("../assets/img/kongbaibg.png");

  &::-webkit-scrollbar {
    display: inline-block !important;
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #05121D;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f2f2f2;
    border-radius: 10px;
  }
}

.forum2 {
  //background: rgba(14, 62, 108, 0.8);
  box-sizing: border-box;
  border-radius: 16px;
  padding: 30px 40px 40px 40px;
  color: white;
  //min-height: 600px;
  min-height: 78vh;

  overflow: hidden;
  margin-bottom: 40px;

}


/* 关键：使用深度选择器修改表格标题样式 */
::v-deep .el-table__header {
  border-radius: 15px 15px 0 0;
  overflow: hidden;
}

::v-deep .el-table__body tr:hover > td > .cell > button {
  color: #0090FF !important;
}

::v-deep .el-table {
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

/* 标题单元格背景色和边框 */
::v-deep .el-table__header th {
  background-color: #0566B5 !important; /* 标题背景色 */
  color: white;
  border-bottom: none !important;
}

/* 表格整体圆角 */
::v-deep .el-table--border {
  border-radius: 16px;
  overflow: hidden;
  border: none !important;
}

::v-deep .el-table__body tr:hover > td {
  background-color: transparent !important; /* 覆盖默认悬停背景色 */
  color: #0090FF !important;
}

/* 核心：表格内容区域背景透明 */
/* 表格整体背景透明 */
::v-deep .el-table {
  background-color: transparent !important;
}

/* 表格内容行背景透明 */
::v-deep .el-table__body tr {
  background-color: transparent !important;
  color: white;
  cursor: pointer;
}

/* 表格单元格背景透明 */
::v-deep .el-table__body td {
  background-color: transparent !important;
  border-color: #516D9E !important;
}

/* 展开行背景透明（如需） */
::v-deep .el-table__expanded-cell {
  background-color: transparent !important;
}

::v-deep .el-table::before {
  display: none;
}

::v-deep .el-table--border::after, .el-table--group::after, .el-table::before {
  display: none;
}


/deep/ {
  .el-textarea__inner {
    background: #0A2846;
    border-color: #0694FC;
    color: white;
  }

  .el-textarea__inner:focus {
    border-color: #0694FC !important;
  }

  .el-textarea__inner:hover {
    border-color: #0694FC !important;
  }

  .sformin .el-form-item {
    margin-bottom: 10px;
  }

  .sformin .el-input__inner {
    height: 60px;
    background: rgba(6, 15, 30, 0.5);
    border-radius: 16px;
    font-size: 18px;
    border: solid 1px #0694FC;
    color: white;
  }

  .sformin .el-form-item__label {
    height: 60px;
    line-height: 60px;
    color: white;
    font-size: 18px;
  }

  .sformin .el-range-input {
    color: white;
    font-size: 18px;
    background: rgba(14, 62, 108, 0);
  }

  .sformin .el-range-separator {
    line-height: 54px;
    color: white;
  }
}

.mlogo1 {
  width: 80px;
  height: 80px;
}

.mlp1 {
  font-size: 33px;
}

.mlp2 {
  font-size: 11px;
  letter-spacing: 0 !important;
}

.searbtn1 {
  width: 60PX;
  height: 60PX;
  text-align: center;
  line-height: 60PX;
  display: inline-block;
  background: #0090FF;
  border-radius: 16px;
  font-size: 24px;
  color: white;
  margin-right: 10px;
}

.searbtn2 {
  width: 60PX;
  height: 60PX;
  text-align: center;
  line-height: 60PX;
  display: inline-block;
  background: #DCDFE6;
  border-radius: 16px;
}

</style>